
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organizationSlug]/roles/[roleId]",
      function () {
        return require("private-next-pages/[organizationSlug]/roles/[roleId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[organizationSlug]/roles/[roleId]"])
      });
    }
  